import React from 'react';
import { Link } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <ExclamationTriangleIcon className="mx-auto h-16 w-16 text-yellow-500" />
        <h1 className="mt-4 text-4xl font-bold text-slate-900">404</h1>
        <p className="mt-2 text-lg text-slate-600">Page not found</p>
        <p className="mt-1 text-slate-500">The page you're looking for doesn't exist.</p>
        <Link to="/dashboard" className="mt-6 inline-block btn-primary">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
